export const strings = {
  title: 'Report a Bug',
  description: 'Tell us what went wrong so we can address it.',
  descriptionWithHelpCenter:
    'Use this to quickly report issues that do not require a reply. If you need a response, please contact Support through the',
  placeHolder: 'Describe the issue',
  primaryText: 'Submit Report',
  secondaryText: 'Cancel',
  connectionIssueTextBefore: 'Having connection issues? Try ',
  connectionIssueTextLink: 'refreshing your status',
  connectionIssueTextAfter: '  first.',
  resetAccountTextLink: 'resetting your account',
  unsupportedLocaleErrorTitle: 'Region not supported',
  unsupportedLocaleError:
    'Contact Center Pro is only officially supported in the United States and Canada. Bug reports submitted from other regions are not investigated.',
  verifyLocaleLink: "I'm in a supported region",
  verifyLocaleErrorPermissionDenied:
    'Location access was denied. Please enable it in your browser settings and try again.',
  verifyLocaleErrorFailed:
    'Unable to determine your location. Please try again.',
  verifyLocaleLinkTooltip:
    "Uses your device's precise GPS location, requested via the browser, to confirm you're in a supported region (United States or Canada).",
} as const;
